<script>
    import { Potions } from "./services/potions";
    import { Ingredients } from "./stores/ingredientsStore";
    import { Storage } from "./utils/storage";
    import SelectEffect from "./components/SelectEffect.svelte";
    import Stats from "./components/Stats.svelte";
    import SkillInput from "./components/SkillInput.svelte";
    import PotionShelf from "./components/PotionShelf.svelte";
    import { favoritePotions } from "./data/favoritePotions";
    import Checkbox from "./components/Checkbox.svelte";

    // Skill
    let skill = Storage.skill() || 100;

    $: Storage.setSkill(skill);
    $: effectsVisible = skill < 15
        ? 0
        : skill < 30
            ? 1
            : skill < 45
                ? 2
                : skill < 60
                    ? 3
                    : 4;

    // Potions
    let potions = Storage.potions() || favoritePotions;
    $: Storage.setPotions(potions);
    function addPotion(potion) {
        potions = [ ...potions, potion ];
    }
    function removePotion(index) {
        potions = potions.filter((e, i) => i !== index);
    }
    function loadPotion(index) {
        const potion = potions[index];
        selectedIngredients = potion.ingredients;
    }
    
    // Selected effects
    let selectedEffects = ["Restore Fatigue", "Fortify Fatigue"];
    function selectEffect(effect) {
        if (!selectedEffects.find(e => e === effect)) {
            selectedEffects = [ ...selectedEffects, effect ];
        }
    }
    function deselectEffect(effect) {
        selectedEffects = selectedEffects.filter(e => e !== effect);
    }
    
    // Hovered ingredient
    let hoveredIngredient = "";
    function hover(ingredient) {
        hoveredIngredient = ingredient;
    }
    function unhover() {
        hoveredIngredient = "";
    }

    // Selected ingredients
    let selectedIngredients = [];
    function toggleIngredient(ingredient) {
        if (selectedIngredients.find(it => it === ingredient)) {
        selectedIngredients = selectedIngredients.filter(it => it !== ingredient);
        } else {
            selectedIngredients = [ ...selectedIngredients, ingredient ];
        }
    }

    // Hovered effect
    let hoveredEffect = "";
    function hoverEffect(effect) {
        hoveredEffect = effect;
    }
    function unhoverEffect() {
        hoveredEffect = "";
    }

    //Final potion
    $: potion = Potions.potion(effectsVisible, ...selectedIngredients);

    let mwOn = Storage.mwOn() === null 
        ? true
        : Storage.mwOn();
    $: Storage.setMwOn(mwOn);
    let trOn = Storage.trOn() === null 
        ? false
        : Storage.trOn();
    $: Storage.setTrOn(trOn);
    let bmOn = Storage.bmOn() === null 
        ? false
        : Storage.bmOn();
    $: Storage.setBmOn(bmOn);
</script>

<main>
    <div class="toolbar">
        <SkillInput value={skill} onChange={v => skill = v} />
        <Checkbox label="Morrowind" checked={mwOn} on:click={() => mwOn = !mwOn} />
        <Checkbox label="Tribunal" checked={trOn} on:click={() => trOn = !trOn} />
        <Checkbox label="Bloodmoon" checked={bmOn} on:click={() => bmOn = !bmOn} />
    </div>
    <div class="content">
        <div class="content-left">
            <div class="selected-effects">
                {#each selectedEffects as effect}
                    <div>
                        <div class="selected-effect" title="Remove" on:click={deselectEffect(effect)}>
                            <img src={`/images/effects/${effect.replaceAll(" ", "_")}.jpg`} alt="glyph" />
                            <span class="selected-effect-name">{effect}</span>
                        </div>
                        <div class="effects-ingredients">
                            {#each Ingredients.withEffect(effect, { effectsVisible, mwOn, trOn, bmOn }) as ingredient}
                                <div 
                                    class={`
                                        ingredient 
                                        ${hoveredIngredient === ingredient ? "hovered" : ""}
                                        ${selectedIngredients.includes(ingredient) ? "selected" : ""}
                                    `}
                                    on:click={toggleIngredient(ingredient)} 
                                    on:mouseenter={hover(ingredient)}
                                    on:mouseleave={unhover}
                                >
                                    <img src={`/images/ingredients/${ingredient.name.replaceAll(" ", "_")}.png`} alt="glyph" />
                                    {#if ingredient.isTribunal}
                                        <span class="expansion-mark">TR</span>
                                    {/if}
                                    {#if ingredient.isBloodmoon}
                                        <span class="expansion-mark">BM</span>
                                    {/if}
                                    <span class="selected-effect-name">
                                        {ingredient.name}
                                    </span>
                                    <div class="stat">
                                        <Stats value={ingredient.value} weight={ingredient.weight} />
                                    </div>
                                </div>
                            {/each}
                        </div>
                    </div>
                {/each}
                <div class="select-effect">
                    <SelectEffect 
                        {effectsVisible} {mwOn} {trOn} {bmOn} 
                        filter={e => !selectedEffects.includes(e)} 
                        onSelect={selectEffect} 
                    />
                </div>
            </div>
            <div class="selected-ingredients">
                {#each selectedIngredients as ingredient}
                    <div>
                        <div class="selected-ingredient" on:click={toggleIngredient(ingredient)}>
                            <img src={`/images/ingredients/${ingredient.name.replaceAll(" ", "_")}.png`} alt="glyph" />
                            {#if ingredient.isTribunal}
                                <span class="expansion-mark">TR</span>
                            {/if}
                            {#if ingredient.isBloodmoon}
                                <span class="expansion-mark">BM</span>
                            {/if}
                            <span class="selected-effect-name">{ingredient.name}</span>
                            <div class="stat">
                                <Stats value={ingredient.value} weight={ingredient.weight} />
                            </div>
                        </div>
                        <div class="ingredients-effects">
                            {#each ingredient.effects.slice(0, effectsVisible) as effect}
                                <div 
                                    class={`
                                        effect 
                                        ${hoveredEffect === effect ? "hovered" : ""}
                                        ${potion?.effects.includes(effect) ? "resulted" : ""}
                                    `}
                                    on:mouseenter={hoverEffect(effect)}
                                    on:mouseleave={unhoverEffect}
                                >
                                    <img src={`/images/effects/${effect.replaceAll(" ", "_")}.jpg`} alt="glyph" />
                                    <span class="selected-effect-name">{effect}</span>
                                </div>
                            {/each}
                        </div>
                    </div>
                {/each}
            </div>
            {#if potion}
                <div class="potion">
                    <div class="potion-actions">
                        <button on:click={addPotion(potion)}>Save</button>
                        <input 
                            placeholder="Potion name"
                            value={potion.name} 
                            on:change={e => potion.name = e.target.value}
                        />
                    </div>
                    <Stats value={potion.value} weight={potion.weight} />
                    <div class="potion-effects">
                        {#each potion.effects as effect}
                            <div class="effect">
                                <img src={`/images/effects/${effect.replaceAll(" ", "_")}.jpg`} alt="glyph" />
                                <span class="selected-effect-name">{effect}</span>
                            </div>
                        {/each}
                    </div>
                </div>
            {/if}
        </div>
        <div class="content-right">
            <PotionShelf potions={potions} onLoad={loadPotion} onRemove={removePotion} />
        </div>
    </div>
</main>

<style>
	main {
		padding: 1em;
        display: flex;
        flex-direction: column;

        max-height: 100%;
    }
    
    .toolbar {
        height: 40px;

        display: flex;
    }
    .content {
        display: flex;
        justify-content: space-between;
        max-height: calc(100% - 40px);
    }
    .content-right {
        min-width: 300px;
        max-width: 300px;
        margin-left: auto;
        min-height: 100%;
    }

    .selected-effects {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
    }
    .selected-effects > * {
        margin-right: 16px;
    }
    .selected-effect {
        display: flex;
        align-items: center;

        height: 36px;
        width: 350px;

        padding: 2px;

        cursor: pointer;

        border-radius: 4px;

        margin-top: 32px;
    }
    .select-effect {
        margin-top: 32px;
        width: 350px;
    }
    .selected-effect:hover {
        background-color: #bd1454cc;
    }
    .selected-effect-name {
        margin-left: 8px;
        margin-top: 4px;
    }

    .ingredients {
        display: flex;
    }
    .effects-ingredients {
        width: 350px;

        margin-top: 16px;
    }
    .ingredient {
        display: flex;
        align-items: center;
        justify-content: space-between;

        cursor: pointer;
        line-height: 32px;
        border-radius: 4px;

        margin-top: 2px;
    }
    .ingredient.hovered {
        background-color: #2f304fcc;
    }
    .ingredient.selected {
        background-color: #3c795bcc;
    }

    .selected-ingredients {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
    }
    .selected-ingredients > * {
        margin-right: 16px;
    }
    .selected-ingredient {
        display: flex;
        align-items: center;

        height: 36px;
        width: 350px;

        padding: 2px;

        cursor: pointer;

        border-radius: 4px;

        margin-top: 32px;
    }
    .selected-ingredient:hover {
        background-color: #bd1454cc;
    }

    .ingredients-effects {
        width: 350px;

        margin-top: 16px;
    }
    .effect {
        display: flex;
        align-items: center;

        line-height: 36px;
        border-radius: 4px;

        padding: 2px 4px;

        margin-top: 2px;
    }
    .effect.hovered {
        background-color: #2f304fcc;
    }
    .effect.resulted {
        background-color: #451212cc;
    }

    .potion {
        margin-top: 32px;
    }
    .potion-actions {
        margin-bottom: 8px;
    }
    .potion-effects {
        display: flex;
    }

    .stat {
        margin-left: auto;
    }

    .expansion-mark {
        font-size: 8px;
        margin-left: -11px;
        line-height: 8px;
        margin-bottom: 23px;
    }
</style>